'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URLInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseClearableTextField = require('@bibliocommons/base-clearable-text-field');

var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var URLInput = exports.URLInput = function (_BcReactComponent) {
  _inherits(URLInput, _BcReactComponent);

  function URLInput(props) {
    _classCallCheck(this, URLInput);

    var _this = _possibleConstructorReturn(this, (URLInput.__proto__ || Object.getPrototypeOf(URLInput)).call(this, props));

    _this.bindAll('clearPreview', 'handleChange');
    return _this;
  }

  _createClass(URLInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ url: value }));
    }
  }, {
    key: 'clearPreview',
    value: function clearPreview() {
      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ url: '' }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-url-input' },
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: 'user_list_url_label' },
          function (message) {
            return _react2.default.createElement(
              'label',
              { htmlFor: 'list-url', id: 'list-url-label' },
              message
            );
          }
        ),
        _react2.default.createElement(_baseClearableTextField2.default, {
          id: 'list-url',
          labelledById: 'list-url-label',
          value: this.props.value,
          maxLength: 1000,
          handleChange: this.handleChange,
          handleClear: this.clearPreview,
          hideClearButton: !this.props.value,
          inputTestId: 'web-item-url',
          clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_web_url' }),
          characterCountSrOnly: true,
          focus: true })
      );
    }
  }]);

  return URLInput;
}(_baseBcReactComponent2.default);

URLInput.propTypes = {
  value: _react.PropTypes.string.isRequired,
  handleWebItemPropertyChange: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(URLInput);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/add-title/lib/components/web-results/components/url-input/components/URLInput.component.js
// module id = 984
// module chunks = 1